
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('circle',{attrs:{"fill":"#FFFFFF","cx":"9","cy":"9","r":"8"}}),_c('path',{attrs:{"d":"M17.1428571,15.0857143 L24,21.9428571 L21.9428571,24 L15.0857143,17.1428571 L15.0857143,16.0594286 L14.7154286,15.6754286 C13.152,17.0194286 11.1222857,17.8285714 8.91428571,17.8285714 C3.99085714,17.8285714 0,13.8377143 0,8.91428571 C0,3.99085714 3.99085714,0 8.91428571,0 C13.8377143,0 17.8285714,3.99085714 17.8285714,8.91428571 C17.8285714,11.1222857 17.0194286,13.152 15.6754286,14.7154286 L16.0594286,15.0857143 L17.1428571,15.0857143 M8.91428571,15.0857143 C12.3428571,15.0857143 15.0857143,12.3428571 15.0857143,8.91428571 C15.0857143,5.48571429 12.3428571,2.74285714 8.91428571,2.74285714 C5.48571429,2.74285714 2.74285714,5.48571429 2.74285714,8.91428571 C2.74285714,12.3428571 5.48571429,15.0857143 8.91428571,15.0857143 M12.3428571,9.6 L9.6,9.6 L9.6,12.3428571 L8.22857143,12.3428571 L8.22857143,9.6 L5.48571429,9.6 L5.48571429,8.22857143 L8.22857143,8.22857143 L8.22857143,5.48571429 L9.6,5.48571429 L9.6,8.22857143 L12.3428571,8.22857143 L12.3428571,9.6 Z","fill":"#000000"}})])])
          )
        }
      }
    